// extracted by mini-css-extract-plugin
export default {"my-editor":"MyEditor_my-editor__XNsnV"};